var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Cooperative_organization"},[_c('div',{staticClass:"main"},[_c('p',{staticClass:"title"},[_vm._v("合作机构")]),_vm._v(" "),_c('img',{staticClass:"img_organization",attrs:{"src":_vm.img4,"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08a0d686","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/CooperativeOrganization.vue
// module id = null
// module chunks = 